function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from "react";
import '../assignment_templates.scss';
import { isEmpty } from "../../core/utils";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import { Button } from "../../core/components";
import TemplateVisibilities from "./templateVisibilities";
import TemplateSummary from "./templateSummary";
import CheckMarkNurturePurple from "../../assets/images/general_icons/check_mark_nurture_purple.svg";
import FeedbackPublishedText from "./FeedbackPublishedText";
import SourceTemplate from "./SourceTemplate";
var AssignmentTemplatesModal = function AssignmentTemplatesModal(_ref) {
  var assignment = _ref.assignment,
    defaultAssignmentName = _ref.defaultAssignmentName,
    savedTemplate = _ref.savedTemplate,
    isOpen = _ref.isOpen,
    templateCreateLoading = _ref.templateCreateLoading,
    templateModalState = _ref.templateModalState,
    sharableCode = _ref.sharableCode,
    context = _ref.context,
    onChangeTemplate = _ref.onChangeTemplate,
    onSubmit = _ref.onSubmit,
    onClose = _ref.onClose,
    onUpdate = _ref.onUpdate;
  var _useState = useState((assignment === null || assignment === void 0 ? void 0 : assignment.visibility) || ''),
    _useState2 = _slicedToArray(_useState, 2),
    templateFor = _useState2[0],
    setTemplateFor = _useState2[1];
  var _useState3 = useState((assignment === null || assignment === void 0 ? void 0 : assignment.name) || defaultAssignmentName),
    _useState4 = _slicedToArray(_useState3, 2),
    templateName = _useState4[0],
    setTemplateName = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    saveFeedback = _useState6[0],
    setSaveFeedback = _useState6[1];
  var _useState7 = useState(true),
    _useState8 = _slicedToArray(_useState7, 2),
    saveButtonDisabled = _useState8[0],
    setSaveButtonDisabled = _useState8[1];
  var _useState9 = useState(assignment === null || assignment === void 0 ? void 0 : assignment.assignment_template),
    _useState10 = _slicedToArray(_useState9, 2),
    sourceTemplate = _useState10[0],
    setSourceTemplate = _useState10[1];
  var _useState11 = useState((assignment === null || assignment === void 0 ? void 0 : assignment.name) || defaultAssignmentName),
    _useState12 = _slicedToArray(_useState11, 2),
    assignmentName = _useState12[0],
    setAssignmentName = _useState12[1];
  var _useState13 = useState('Assessment saved as a template'),
    _useState14 = _slicedToArray(_useState13, 2),
    templateSavedText = _useState14[0],
    setTemplateSavedText = _useState14[1];
  var isRubrics = !!(assignment !== null && assignment !== void 0 && assignment.rubrics);
  var showUpdateTemplate = sourceTemplate && context === 'feedback' && !isRubrics && (sourceTemplate === null || sourceTemplate === void 0 ? void 0 : sourceTemplate.can_edit);
  var closeModal = function closeModal() {
    if (templateCreateLoading) return;
    onClose();
  };
  var submitModal = function submitModal() {
    return onSubmit();
  };
  var handleChangeVisibility = function handleChangeVisibility(visibility, templateName, saveFeedback) {
    context === 'assignment_creation' ? onChangeTemplate(visibility, templateName) : onChangeTemplate(visibility, templateName, saveFeedback);
    setTemplateFor(visibility);
    setTemplateName(templateName);
    setSaveFeedback(saveFeedback);
  };
  var handleCreateNewFromSourceTemplate = function handleCreateNewFromSourceTemplate() {
    setSourceTemplate(false);
    if (showUpdateTemplate) setAssignmentName('(Copy) ' + assignmentName);
  };
  var handleUpdateFeedbackOnTemplate = function handleUpdateFeedbackOnTemplate(template) {
    setTemplateSavedText('Feedback updated on this template');
    setSaveFeedback(true);
    onUpdate(template);
  };
  useEffect(function () {
    setSaveButtonDisabled(isEmpty(templateFor) || !templateName);
  }, [templateFor, templateName]);
  useEffect(function () {
    setTemplateName((assignment === null || assignment === void 0 ? void 0 : assignment.name) || defaultAssignmentName);
    setAssignmentName((assignment === null || assignment === void 0 ? void 0 : assignment.name) || defaultAssignmentName);
  }, [assignment, defaultAssignmentName]);
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpen,
    centered: true,
    size: "lg",
    className: "modal assignment-templates-modal modal-fullscreen-md-down modal-dialog-scrollable"
  }, /*#__PURE__*/React.createElement(ModalBody, {
    className: "modal-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pt-4 pb-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "modal-title px-lg-4",
    id: "exampleModalLabel"
  }, templateModalState === 0 ? /*#__PURE__*/React.createElement("div", {
    className: "mb-2"
  }, context === 'feedback' && /*#__PURE__*/React.createElement(FeedbackPublishedText, null), !showUpdateTemplate && /*#__PURE__*/React.createElement("h4", {
    className: "font-weight-100",
    style: {
      color: '#2C7BE5'
    }
  }, "Save assignment as a template")) : /*#__PURE__*/React.createElement(React.Fragment, null, savedTemplate.visibility === 'public' ? /*#__PURE__*/React.createElement("div", {
    className: "alert alert-warning"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "d-flex align-items-center"
  }, /*#__PURE__*/React.createElement("img", {
    src: CheckMarkNurturePurple
  }), /*#__PURE__*/React.createElement("div", {
    className: "ms-2 text-nurture-purple"
  }, "Pending approval.")), /*#__PURE__*/React.createElement("p", {
    className: "font-weight-100 font-size-16"
  }, "Our Nurture Experts will review this template and if approved, it will be available on Nurture Space for any teacher to use. We will let you know when it is ready!"), /*#__PURE__*/React.createElement("p", {
    className: "font-weight-100 font-size-16"
  }, "In the meantime, this template is saved to your personal templates.")) : /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center"
  }, /*#__PURE__*/React.createElement("img", {
    src: CheckMarkNurturePurple
  }), /*#__PURE__*/React.createElement("div", {
    className: "ms-2 text-nurture-purple"
  }, templateSavedText))))), templateModalState === 0 && !showUpdateTemplate && /*#__PURE__*/React.createElement(TemplateVisibilities, {
    context: context,
    assignmentName: assignmentName,
    isRubrics: !!(assignment !== null && assignment !== void 0 && assignment.rubrics),
    selected: templateFor,
    onChange: handleChangeVisibility
  }), templateModalState === 0 && showUpdateTemplate && /*#__PURE__*/React.createElement(SourceTemplate, {
    sourceAssignment: assignment,
    onCancel: onClose,
    onCreate: handleCreateNewFromSourceTemplate,
    sourceTemplate: sourceTemplate,
    canEdit: showUpdateTemplate,
    onUpdate: handleUpdateFeedbackOnTemplate
  }), templateModalState !== 0 && /*#__PURE__*/React.createElement(TemplateSummary, {
    context: context,
    saveFeedback: saveFeedback,
    savedTemplate: savedTemplate,
    templateFor: templateFor,
    code: sharableCode,
    onclose: closeModal
  })), templateModalState === 0 && !showUpdateTemplate && /*#__PURE__*/React.createElement(ModalFooter, {
    className: "modal-footer"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: closeModal,
    disabled: templateCreateLoading,
    className: "btn btn-light text-danger",
    "data-bs-dismiss": "modal"
  }, "Close"), /*#__PURE__*/React.createElement(Button, {
    type: "button",
    onClick: submitModal,
    disabled: saveButtonDisabled || templateCreateLoading,
    withLoader: true,
    loading: templateCreateLoading,
    loaderText: "Saving",
    className: "btn btn-nurture-purple"
  }, "Save as template")));
};
AssignmentTemplatesModal.defaultProps = {
  context: 'assignment_creation'
};
export default AssignmentTemplatesModal;